/* ============================================================
   MORNING GRIND — POWER BLEND BUY BOX ENGINE
   Theme asset: assets/mgbb.js
   Loaded globally in theme.liquid → runs on theme product page
   AND on PageFly /pages/ URLs (PageFly renders inside the theme).

   Written for unknown DOM timing: uses event delegation on
   document, so it does not care whether the buy box HTML exists
   when this file runs.
   ============================================================ */

(function () {
  'use strict';

  /* Guard against double-loading (e.g. asset linked twice). */
  if (window.__mgbbLoaded) return;
  window.__mgbbLoaded = true;

  /* ==========================================================
     CONFIG — THE ONLY PART YOU EDIT
     ========================================================== */
  var CONFIG = {

    /* Shopify variant IDs, from /products/<handle>.js */
    variants: {
      mocha:    50938671726913,
      vanilla:  50938671759681,
      hazelnut: 51258810138945,
      latte:    52049572397377
    },

    /* Seal Subscriptions selling plan ID */
    sellingPlan: 11236114753,

    /* Product handle — used for the sold-out check.
       Find it in your product URL: /products/THIS-BIT
       If this is wrong, the sold-out check silently skips. */
    productHandle: 'performance-cofffee-mixes-power-blend',

    /* Pricing */
    bagPrice: 39.99,
    servingsPerBag: 15,
    currency: 'USD',

    /* Offers. `bags` drives the flavour picker capacity. */
    offers: {
      sub:  { bags: 2, discount: 0.20, plan: true,  code: null,      label: 'Subscribe' },
      otp4: { bags: 4, discount: 0.15, plan: false, code: 'PB4PACK', label: 'One-time' },
      otp2: { bags: 2, discount: 0.10, plan: false, code: 'PB2PACK', label: 'One-time' },
      otp1: { bags: 1, discount: 0,    plan: false, code: null,      label: 'One-time' }
    },

    defaultOffer: 'sub',

    /* Where to send them after adding to cart.
       '/checkout' = straight to checkout. '/cart' = cart page. */
    destination: '/checkout',

    /* Set false to skip the sold-out stock check. */
    checkStock: true
  };

  /* ==========================================================
     STATE — one record per buy box instance on the page
     ========================================================== */
  var instances = typeof WeakMap === 'function' ? new WeakMap() : null;
  var fallbackStore = [];

  function getState(root) {
    if (instances) {
      if (!instances.has(root)) instances.set(root, newState());
      return instances.get(root);
    }
    for (var i = 0; i < fallbackStore.length; i++) {
      if (fallbackStore[i].el === root) return fallbackStore[i].state;
    }
    var s = newState();
    fallbackStore.push({ el: root, state: s });
    return s;
  }

  function newState() {
    return {
      offer: CONFIG.defaultOffer,
            picks: { mocha: 0, vanilla: 0, hazelnut: 0, latte: 0 },
      soldOut: {},
      busy: false,
      rendered: false
    };
  }

  /* ==========================================================
     HELPERS
     ========================================================== */
  function flavors() { return Object.keys(CONFIG.variants); }

  function capacity(state) {
    var o = CONFIG.offers[state.offer];
    return o ? o.bags : 1;
  }

  function totalPicked(state) {
    return flavors().reduce(function (sum, f) { return sum + (state.picks[f] || 0); }, 0);
  }

  function offerTotal(key) {
    var o = CONFIG.offers[key];
    return CONFIG.bagPrice * o.bags * (1 - o.discount);
  }

  function offerFull(key) {
    return CONFIG.bagPrice * CONFIG.offers[key].bags;
  }

  function perServing(key) {
    var o = CONFIG.offers[key];
    return offerTotal(key) / (o.bags * CONFIG.servingsPerBag);
  }

  function money(n) {
    return '$' + n.toFixed(2) + ' ' + CONFIG.currency;
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function closest(el, selector) {
    if (!el || !el.closest) return null;
    return el.closest(selector);
  }

  /* ==========================================================
     RENDER
     ========================================================== */
  function render(root) {
    var state = getState(root);
    var cap = capacity(state);
    var total = totalPicked(state);

    /* --- Offer cards --- */
    each(root.querySelectorAll('[data-mgbb-offer]'), function (card) {
      var key = card.getAttribute('data-mgbb-offer');
      var selected = key === state.offer;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    /* --- Prices (rendered from config so there is one source of truth) --- */
    each(root.querySelectorAll('[data-mgbb-price]'), function (el) {
      var key = el.getAttribute('data-mgbb-price');
      if (CONFIG.offers[key]) el.textContent = money(offerTotal(key));
    });

    each(root.querySelectorAll('[data-mgbb-perserving]'), function (el) {
      var key = el.getAttribute('data-mgbb-perserving');
      if (CONFIG.offers[key]) el.textContent = '$' + perServing(key).toFixed(2) + ' ' + CONFIG.currency + ' / Serving';
    });

    each(root.querySelectorAll('[data-mgbb-saving]'), function (el) {
      var key = el.getAttribute('data-mgbb-saving');
      if (CONFIG.offers[key]) el.textContent = money(offerFull(key) - offerTotal(key));
    });

    each(root.querySelectorAll('[data-mgbb-billing]'), function (el) {
      var key = el.getAttribute('data-mgbb-billing');
      if (CONFIG.offers[key]) el.textContent = 'Billed ' + money(offerTotal(key)) + ' every month';
    });

    /* --- Flavour circles --- */
    each(root.querySelectorAll('[data-mgbb-flavor]'), function (btn) {
      var f = btn.getAttribute('data-mgbb-flavor');
      var count = state.picks[f] || 0;
      var out = !!state.soldOut[f];

      btn.setAttribute('data-count', String(count));
      btn.classList.toggle('is-soldout', out);
      btn.disabled = out;

      var badge = btn.querySelector('[data-mgbb-count]');
      if (badge) badge.textContent = String(count);

      var name = btn.getAttribute('data-mgbb-name') || f;
      btn.setAttribute('aria-label', out
        ? name + ' — sold out'
        : name + ', ' + count + ' selected. Click to add one.');
    });

    /* --- Counter pill --- */
    var counter = root.querySelector('[data-mgbb-counter]');
    if (counter) {
      counter.textContent = total + ' of ' + cap + (cap === 1 ? ' bag selected' : ' bags selected');
      counter.setAttribute('data-state', total === 0 ? 'empty' : (total === cap ? 'full' : 'partial'));
    }

    /* --- Reset link --- */
    var reset = root.querySelector('[data-mgbb-reset]');
    if (reset) reset.classList.toggle('is-visible', total > 0);

    /* --- CTA --- */
    var cta = root.querySelector('[data-mgbb-cta]');
    if (cta) {
      var ready = total === cap && !state.busy;
      cta.disabled = !ready;
      cta.classList.toggle('is-busy', state.busy);

      var labelEl = cta.querySelector('[data-mgbb-cta-label]') || cta;
      if (state.busy) {
        labelEl.textContent = 'Adding to cart\u2026';
      } else if (total < cap) {
        labelEl.textContent = 'Pick ' + (cap - total) + ' more ' + (cap - total === 1 ? 'bag' : 'bags');
      } else {
        labelEl.textContent = cta.getAttribute('data-mgbb-cta-default') || 'Add to cart';
      }
    }

    /* --- CTA subtext --- */
    var sub = root.querySelector('[data-mgbb-cta-sub]');
    if (sub) {
      sub.textContent = CONFIG.offers[state.offer].plan
        ? money(offerTotal(state.offer)) + ' today, then every month. Cancel or pause anytime.'
        : money(offerTotal(state.offer)) + ' \u2014 one-time purchase, no subscription.';
    }

    state.rendered = true;
  }

  /* ==========================================================
     ACTIONS
     ========================================================== */
  function selectOffer(root, key) {
    if (!CONFIG.offers[key]) return;
    var state = getState(root);
    state.offer = key;
    trimPicks(state);
    render(root);
  }

  /* If the new plan holds fewer bags than are currently picked,
     remove from the largest counts down until it fits. */
  function trimPicks(state) {
    var cap = capacity(state);
    var guard = 0;
    while (totalPicked(state) > cap && guard < 50) {
      var biggest = null;
      flavors().forEach(function (f) {
        if (state.picks[f] > 0 && (biggest === null || state.picks[f] > state.picks[biggest])) biggest = f;
      });
      if (biggest === null) break;
      state.picks[biggest]--;
      guard++;
    }
  }

  function addFlavor(root, f) {
    var state = getState(root);
    if (state.soldOut[f]) return;

    var cap = capacity(state);

    /* Single-bag plans swap rather than block — much better UX. */
    if (cap === 1) {
      flavors().forEach(function (k) { state.picks[k] = 0; });
      state.picks[f] = 1;
    } else if (totalPicked(state) < cap) {
      state.picks[f] = (state.picks[f] || 0) + 1;
    }
    render(root);
  }

  function removeFlavor(root, f) {
    var state = getState(root);
    if (state.picks[f] > 0) state.picks[f]--;
    render(root);
  }

  function resetPicks(root) {
    var state = getState(root);
    flavors().forEach(function (f) { state.picks[f] = 0; });
    render(root);
  }

  function toggleOtp(root, btn) {
    var panel = root.querySelector('[data-mgbb-otp-panel]');
    if (!panel) return;
    var open = panel.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function showError(root, msg) {
    var el = root.querySelector('[data-mgbb-error]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
  }

  function clearError(root) {
    var el = root.querySelector('[data-mgbb-error]');
    if (el) el.classList.remove('is-visible');
  }

  /* ==========================================================
     CART
     ========================================================== */
  function submit(root) {
    var state = getState(root);
    if (state.busy) return;

    var offer = CONFIG.offers[state.offer];
    if (totalPicked(state) !== offer.bags) return;

    clearError(root);
    state.busy = true;
    render(root);

    /* Zero out only OUR variants, so an existing cart on the
       theme product page is not wiped. */
    var updates = {};
    flavors().forEach(function (f) { updates[CONFIG.variants[f]] = 0; });

    var items = flavors()
      .filter(function (f) { return state.picks[f] > 0; })
      .map(function (f) {
        var item = { id: CONFIG.variants[f], quantity: state.picks[f] };
        if (offer.plan) item.selling_plan = CONFIG.sellingPlan;
        return item;
      });

    /* Welcome Kit — month-1 gifts (subscription only).
       No selling_plan on gifts, so they don't recur. */
    if (offer.plan) {
      items.push({ id: 52060474409281, quantity: 1, properties: { _welcome_kit: 'm1-stickers' } });
      items.push({ id: 52059048247617, quantity: 1, properties: { _welcome_kit: 'm1-pdf' } });
    }

    post('/cart/update.js', { updates: updates })
      .then(function () { return post('/cart/add.js', { items: items }); })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Add to cart failed'); });
        return res.json();
      })
      .then(function () {
        var dest = CONFIG.destination;
        if (offer.code) {
          dest = '/discount/' + encodeURIComponent(offer.code) + '?redirect=' + encodeURIComponent(CONFIG.destination);
        }
        window.location.href = dest;
      })
      .catch(function (err) {
        state.busy = false;
        render(root);
        showError(root, (err && err.message) || 'Something went wrong. Please try again.');
        if (window.console) console.error('[mgbb]', err);
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* ==========================================================
     STOCK CHECK
     ========================================================== */
  function checkStock(root) {
    if (!CONFIG.checkStock || !CONFIG.productHandle) return;
    var state = getState(root);

    fetch('/products/' + CONFIG.productHandle + '.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.variants) return;
        var byId = {};
        data.variants.forEach(function (v) { byId[v.id] = v; });

        var changed = false;
        flavors().forEach(function (f) {
          var v = byId[CONFIG.variants[f]];
          if (v && v.available === false) {
            state.soldOut[f] = true;
            if (state.picks[f] > 0) { state.picks[f] = 0; changed = true; }
            changed = true;
          }
        });
        if (changed) render(root);
      })
      .catch(function () { /* stock check is best-effort; never block the buy box */ });
  }

  /* ==========================================================
     INIT + EVENT DELEGATION
     ========================================================== */
  function initAll() {
    each(document.querySelectorAll('[data-mgbb]'), function (root) {
      var state = getState(root);
      if (state.rendered) return;

      /* Honour a per-instance default set in the HTML. */
      var preset = root.getAttribute('data-mgbb-default');
      if (preset && CONFIG.offers[preset]) state.offer = preset;

      render(root);
      checkStock(root);
    });
  }

  document.addEventListener('click', function (e) {
    var root = closest(e.target, '[data-mgbb]');
    if (!root) return;

    /* Minus sits inside the flavour button — check it first. */
    var minus = closest(e.target, '[data-mgbb-minus]');
    if (minus) {
      e.preventDefault();
      e.stopPropagation();
      var mf = closest(minus, '[data-mgbb-flavor]');
      if (mf) removeFlavor(root, mf.getAttribute('data-mgbb-flavor'));
      return;
    }

    var flavor = closest(e.target, '[data-mgbb-flavor]');
    if (flavor) {
      e.preventDefault();
      addFlavor(root, flavor.getAttribute('data-mgbb-flavor'));
      return;
    }

    var card = closest(e.target, '[data-mgbb-offer]');
    if (card) {
      selectOffer(root, card.getAttribute('data-mgbb-offer'));
      return;
    }

    var otp = closest(e.target, '[data-mgbb-otp-toggle]');
    if (otp) {
      e.preventDefault();
      toggleOtp(root, otp);
      return;
    }

    var reset = closest(e.target, '[data-mgbb-reset]');
    if (reset) {
      e.preventDefault();
      resetPicks(root);
      return;
    }

    var cta = closest(e.target, '[data-mgbb-cta]');
    if (cta) {
      e.preventDefault();
      submit(root);
      return;
    }
  });

  /* Init on every plausible timing, since PageFly may paint late. */
  initAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  }
  window.addEventListener('load', initAll);

  /* Catch buy boxes injected after load (PageFly, section reloads). */
  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function () { initAll(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Shopify theme editor: re-init when a section is re-rendered. */
  document.addEventListener('shopify:section:load', initAll);

  window.MGBB = { config: CONFIG, init: initAll };
})();